/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
/* eslint-disable import/order */
import type { SidebarConfigData } from '@jira/navigation-apps__shared-types/src/types.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { useResource, type RouteResourceError } from '@atlassian/react-resource-router';

type UseNavigationGlobalResourceReturn = {
	data: SidebarConfigData | null;
	loading: boolean;
	error: RouteResourceError | null;
};

export const useNavigationGlobalResource = (): UseNavigationGlobalResourceReturn => {
	const { data, loading, error } = useResource(navigationSidebarGlobalResource);

	return { data: data && data.response, loading, error };
};
